import React from 'react';
import styles from './Tooltip.css';

const Tooltip = ({ step, primaryProps, tooltipProps }) => (
  <div {...tooltipProps} className={styles.container}>
    <div className={styles.body}>
      {step.content && <div className={styles.content}>{step.content}</div>}
    </div>
    <div className={styles.footer}>
      <button className="btn btn-primary" {...primaryProps}>
        {step.locale.close}
      </button>
    </div>
  </div>
);

export default Tooltip;
